import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: calc(100% - 60px);
  padding: 40px 30px;
  background: #fff;
`;

export const Title = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-family: GmarketSansMedium, sans-serif;
  font-size: 22px;
`;

export const OptionWrapper = styled.span`
  display: inline-block;
  margin-left: auto;
`;

export const Option = styled.span`
  cursor: pointer;
  font-size: 12px;
  font-family: Gulim, sans-serif;
  &:not(:last-child) {
    padding: 0 10px;
    border-right: 1px solid #e3e3e3;
  }
  &:last-child {
    padding-left: 10px;
  }

  ${(props) =>
    props.isSelected &&
    css`
      color: #ee1a21;
    `}
`;

export const Table = styled.table`
  border-collapse: collapse;
  margin-top: 20px;
  table-layout: fixed;
  width: 100%;

  border: 1px solid #e3e3e3;

  & > thead th {
    height: 48px;
    text-align: center;
    background: #fafafa;
    border-bottom: 1px solid #e3e3e3;
    &:nth-child(2) {
      text-align: left;
      text-indent: 20px;
    }
  }
  & > tbody > tr {
    border-bottom: 1px solid rgb(236, 239, 243);
  }
  & > tbody > tr:last-child {
    border-bottom: none;
  }

  & > tbody td {
    height: 47px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const TeamCell = styled.div`
  display: flex;
  align-content: center;
  justify-content: flex-start;
  margin-left: 10px;
  line-height: 20px;

  & > div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    vertical-align: middle;
    margin-left: 10px;
  }
`;
